		        
class KDOPopUpBtn {
    constructor(btn) {
        this.btn = btn; 
    } 
    createPopupContent() {
        let html; 
        html = document.createElement("section");
        html.classList.add("landing-page--popup-container");
        html.setAttribute("aria-hidden", "true");
        html.innerHTML = `<div class="inner--popup"> 

                <button class="close-popup--btn">
                    <div class="close-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="35" height="35" viewBox="0,0,256,256">
                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(8.53333,8.53333)"><path d="M7,4c-0.25587,0 -0.51203,0.09747 -0.70703,0.29297l-2,2c-0.391,0.391 -0.391,1.02406 0,1.41406l7.29297,7.29297l-7.29297,7.29297c-0.391,0.391 -0.391,1.02406 0,1.41406l2,2c0.391,0.391 1.02406,0.391 1.41406,0l7.29297,-7.29297l7.29297,7.29297c0.39,0.391 1.02406,0.391 1.41406,0l2,-2c0.391,-0.391 0.391,-1.02406 0,-1.41406l-7.29297,-7.29297l7.29297,-7.29297c0.391,-0.39 0.391,-1.02406 0,-1.41406l-2,-2c-0.391,-0.391 -1.02406,-0.391 -1.41406,0l-7.29297,7.29297l-7.29297,-7.29297c-0.1955,-0.1955 -0.45116,-0.29297 -0.70703,-0.29297z"></path></g></g>
                            </svg>
                    </div>
                    <div class="screen-reader-text">Close KDO Popup Button</div> 
                </button>
                <div class="popup-container">
                    <div class="popup-loader">
                        <div class="loading-icon">
                            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        </div>
                        <div class="popup-loader__text">LOADING</div> 
                    </div>
                    <div class="popup-content  " >
                        ${this.iframe()}
                    </div>
                </div><!-- container -->
            </div>`;
        return html;
    }

    openPopUp() {
        document.body.appendChild(this.createPopupContent());
        document.body.style = "overflow-y: hidden";
        this.addCloseEventListenerToOverlay();
    }

    addEventListenerToPopUpBtn() { 
        if (this.urlIsValid()) {
            this.btn.addEventListener("click", 
                function(){
                    this.openPopUp.bind(this); 
                }
               , 
            true);
        }else{
            console.log("You are missing the url")
        }
    }

    urlIsValid() {
        console.log(this.videoUrl );
        console.log(this.videoUrl.trim());
        return this.videoUrl && this.videoUrl.trim() !== ""; // Check if the URL exists and is not empty
    }

    open() { 
        this.openPopUp();
    }

    addEventListenerToClosePopUpBtn() {
        let closeBtn = document.querySelector(".close-popup--btn");
        closeBtn.addEventListener("click", function() {
            document.body.style = "overflow-y: auto";
            document.querySelector(".landing-page--popup-container").remove();
        });
    }

    addCloseEventListenerToOverlay() {
        let closeOverlay = document.querySelector(".landing-page--popup-container");
        if(closeOverlay != null){
            closeOverlay.addEventListener("click", function() {
                document.body.style = "overflow-y: auto";
                document.querySelector(".landing-page--popup-container").remove();
            });
        }
        
    }

    iframe(){
        let iframe = `<iframe width="560" height="315" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
        return iframe;
    }
} 


class VideoPopUpBtn extends KDOPopUpBtn {
    constructor(btn) {
        super(btn);
        this.videoUrl = btn.getAttribute("data-video-url"); 
    }

    createPopupContent() {
        const html = super.createPopupContent();
        let src = this.videoUrl;
        if (src.includes('watch')) {
            src =  src.replace("watch?v=", "embed/");
         }    
        const iframe = `<iframe width="560" height="315" src="${src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
         
        // Append the iframe to the existing popup content
        const popupContent = html.querySelector(".popup-content");
        popupContent.classList.add("video-popup");
        popupContent.innerHTML = iframe;
        
        return html;
    }
}

class FilePopUpBtn extends KDOPopUpBtn {
    constructor(btn) {
        super(btn);
        this.fileUrl = btn.getAttribute("data-file-url"); 
    }

    createPopupContent() {
        const html = super.createPopupContent();
        const fileLink = this.fileUrl;
        const iframe = `<iframe style="width: 100%; height: 100%;" src="${this.fileUrl}" t frameborder="0" allowfullscreen></iframe>`;
        
        // Append the file link to the existing popup content
        const popupContent = html.querySelector(".popup-content");
        popupContent.classList.add("file-popup");
        popupContent.innerHTML = iframe;
        
        return html;
    }
}


class FormPopUpBtn extends KDOPopUpBtn {
    constructor(btn) {
        super(btn);
        this.formId = btn.getAttribute("data-form-id"); 
    }

    createPopupContent() {
        const html = super.createPopupContent();
        const formId = this.formId;
        const formDiv = `<div class="${this.formId}"></div>`;
        
        // Append the file link to the existing popup content
        const popupContent = html.querySelector(".popup-content");
        popupContent.classList.add("form-popup");
        popupContent.innerHTML = formDiv; 
        return html;
    }
}

class DivPopUpBtn extends KDOPopUpBtn {
    constructor(btn) {
        super(btn);
        this.divSelector = btn.getAttribute("data-selector"); 
        this.parent = btn.parentElement;
    }

    createPopupContent() {
        const html = super.createPopupContent();
        const parent = this.parent; 
        const divSelector = parent.querySelector(this.divSelector).innerHTML; 
        const popupContent = html.querySelector(".popup-content"); 
        if(parent.classList.length > 0){ 
        	const parentClass = parent.classList; 
        	popupContent.classList.add(parentClass);
        }  
        popupContent.classList.add("div-popup");
        popupContent.innerHTML = divSelector; 
        return html;
    }
}